export const ENQUIRY_MANAGEMENT_DETAILS = "ENQUIRY_MANAGEMENT_DETAILS";
export const ENQUIRY_MANAGEMENT_DETAILS_SUCCESS =
  "ENQUIRY_MANAGEMENT_DETAILS_SUCCESS";
export const ENQUIRY_MANAGEMENT_DETAILS_FAIL =
  "ENQUIRY_MANAGEMENT_DETAILS_FAIL";

export const ENQUIRY_MANAGEMENT_CSV_START = "ENQUIRY_MANAGEMENT_CSV_START";
export const ENQUIRY_MANAGEMENT_CSV_SUCCESS = "ENQUIRY_MANAGEMENT_CSV_SUCCESS";
export const ENQUIRY_MANAGEMENT_CSV_ERROR = "ENQUIRY_MANAGEMENT_CSV_ERROR";
